import { render, staticRenderFns } from "./Barniz.vue?vue&type=template&id=4af39837&scoped=true&"
import script from "./Barniz.vue?vue&type=script&lang=js&"
export * from "./Barniz.vue?vue&type=script&lang=js&"
import style0 from "./Barniz.vue?vue&type=style&index=0&id=4af39837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af39837",
  null
  
)

export default component.exports